import { Timeline } from 'antd';
import React from 'react'
import TitleTemp from './TitleTemp';
import ComingSoon from './ComingSoon';

interface TimelineInterface {
    dates: string[];
    desc: string[];
    colors: string[];
    showTitle: boolean;
    comingSoon?: boolean;
}

const TimelineComp: React.FC<TimelineInterface> = ({ dates, desc, colors, showTitle, comingSoon = false }) => {
    if (comingSoon) {
        return (
            <section id='timeline' className='pt-1 pb-8 flex flex-col items-center justify-center text-center'>
                {showTitle && <TitleTemp name='Timeline' />}
                <ComingSoon description={`We're working hard to bring you our timeline. Stay tuned!`} />
            </section>
        );
    }

    return (
        <section id='timeline' className='pt-1'>
            {showTitle && <TitleTemp name='Timeline' />}
            <Timeline mode="alternate" className='mt-12'>
                {dates.map((date, index) => (
                    <Timeline.Item
                        key={index}
                        dot={
                            <div
                                style={{
                                    width: 16,
                                    height: 16,
                                    borderRadius: '50%',
                                    backgroundColor: colors[index],
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <div className="w-2 h-2 bg-white rounded-full" />
                            </div>
                        }
                    >
                        <div className="flex flex-col text-base md:text-lg px-5 relative -top-6">
                            <strong>{date}</strong>
                            <p className="text-gray-500">{desc[index]}</p>
                        </div>
                    </Timeline.Item>
                ))}
            </Timeline>
        </section>
    );
}

export default TimelineComp;
